import React from "react";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import ListGroup from "react-bootstrap/ListGroup";
import FormAlert from "./FormAlert";
import { useEventsByTd } from "./../util/db";
import "./DashboardItems.scss";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

function DashboardItemsTd(props) {
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
  } = useEventsByTd(props.auth.user.uid);

  const itemsAreEmpty = !items || items.length === 0;

  return (
    <Container>
      {itemsError && (
        <div className="mb-3">
          <FormAlert type="error" message={itemsError.message} />
        </div>
      )}

      {!itemsAreEmpty && (
        <Card
          key={props.hole_score_id}
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: "1px solid rgba(0, 0, 0, 0.06)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "12px 12px 0 0",
              borderBottom: "none",
            }}
          >
            <Card.Title style={{ color: "white", margin: 0 }}>
              Events
            </Card.Title>
          </Card.Header>

          {(itemsStatus === "loading" || itemsAreEmpty) && (
            <Card.Body className="py-5 px-3 text-center">
              {itemsStatus === "loading" && (
                <Spinner animation="border" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              )}

              {/* {itemsStatus !== "loading" && itemsAreEmpty && (
                <>No events yet</>
              )} */}
            </Card.Body>
          )}

          {itemsStatus !== "loading" && items && items.length > 0 && (
            <ListGroup
              variant="flush"
              style={{ borderRadius: "0 0 12px 12px" }}
            >
              {items.map((item, index) => (
                <ListGroup.Item
                  key={index}
                  className={
                    `d-flex justify-content-between align-items-center` +
                    (item.featured ? " featured" : "")
                  }
                  style={{
                    borderLeft: "none",
                    borderRight: "none",
                    transition: "background-color 0.2s ease",
                    ...(index === items.length - 1 && {
                      borderBottom: "none",
                      borderRadius: "0 0 12px 12px",
                    }),
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor =
                      "rgba(13, 110, 253, 0.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  <Link
                    to={`/event?event=${item.id}`}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      fontWeight: "500",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#0d6efd")}
                    onMouseLeave={(e) => (e.target.style.color = "inherit")}
                  >
                    {item.name}
                  </Link>
                  <Link
                    to={`/event_manage?event=${item.id}`}
                    style={{
                      textDecoration: "none",
                      fontSize: "1.2rem",
                      transition: "transform 0.2s ease, opacity 0.2s ease",
                      opacity: "0.7",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.1)";
                      e.target.style.opacity = "1";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.opacity = "0.7";
                    }}
                  >
                    ⚙️
                  </Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card>
      )}
      {itemsAreEmpty && (
        <Card
          style={{
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: "1px solid rgba(0, 0, 0, 0.06)",
          }}
        >
          <Card.Body className="text-center py-5">
            <p className="mb-0 text-muted">
              No events yet. Add one by clicking "Create Event" from the LD
              Tools tab.
            </p>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}

export default DashboardItemsTd;
